import { render, staticRenderFns } from "./TypeAhead.vue?vue&type=template&id=47b87906&scoped=true&"
import script from "./TypeAhead.vue?vue&type=script&lang=js&"
export * from "./TypeAhead.vue?vue&type=script&lang=js&"
import style0 from "./TypeAhead.vue?vue&type=style&index=0&id=47b87906&prod&scoped=true&lang=scss&"
import style1 from "./TypeAhead.vue?vue&type=style&index=1&id=47b87906&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b87906",
  null
  
)

export default component.exports